"use strict";

$(function () {
    const container = $(".gift-form");
    const giftFormContainer = container.find("#gift_form_container");
    const giftFormLink = container.find("#gift_form_link");
    const giftEditButton = container.find("#gift_form_edit_link");
    const giftDeleteButton = container.find("#gift_form_delete_button_container");
    const giftContent = container.find("#gift_content");

    function showGiftForm() {
        giftFormContainer.show();
        giftFormLink.hide();
    }

    function hideGiftForm() {
        giftFormContainer.hide();
        giftFormLink.show();
    }

    giftEditButton.click(function (event) {
        showGiftForm();
        giftContent.hide();
        giftEditButton.hide();
        giftDeleteButton.show();
        event.preventDefault();
    });

    container.on("click", "#gift_form_link a", function (event) {
        showGiftForm();
        event.preventDefault();
    });

    container.on("click", "#gift_form_cancel", function (event) {
        hideGiftForm();
        container.find("#gift_form")[0].reset();
        if (container.find("#gift_form_cancel").data("edit-mode") === 1) {
            giftEditButton.show();
            giftContent.show();
            giftDeleteButton.hide();
        }
        event.preventDefault();
    });

    if (window.location.hash === "#gift") {
        showGiftForm();
    }
});
